export enum State {
  unavailable,
  available,
  critical,
}
